module.exports = __webpack_public_path__ + "static/media/nomads-1.60c30ba5.png";